import React from 'react'
import "./Footer.css"
const Footer = () => {
  return (
    <section id='Footer'>
        <div className="container">
            <h5><span>2025 © Barcha huquqlar himoyalangan.</span></h5>

            <div id="Footer-social">
                <a href="https://www.instagram.com/buxoro_tadbirkorlar_klubi" target='_blank' rel="noopener noreferrer"><i class="fa-brands fa-instagram"></i></a>
                {/*<a href="#"><i class="fa-brands fa-twitter" target='_blank' rel="noopener noreferrer"></i></a>*/}
                <a href="https://t.me/buxoro_tadbirkorlar_klubi" target='_blank' rel="noopener noreferrer"><i class="fa-brands fa-telegram"></i></a>
                <a href="https://www.google.com/maps/place/%D0%91%D0%B8%D0%B7%D0%BD%D0%B5%D1%81%D0%BD%D0%B8+%D1%80%D0%B8%D0%B2%D0%BE%D0%B6%D0%BB%D0%B0%D0%BD%D1%82%D0%B8%D1%80%D0%B8%D1%88+%D0%B1%D0%B0%D0%BD%D0%BA%D0%B8+%D0%91%D1%83%D1%85%D0%BE%D1%80%D0%BE+%D0%9A%D0%91%D0%9A%D0%9C/@39.7771924,64.4414957,18z/data=!4m14!1m7!3m6!1s0x3f50059e4be78105:0xdffcc32a2eefa04e!2z0JHQuNC30L3QtdGB0L3QuCDRgNC40LLQvtC20LvQsNC90YLQuNGA0LjRiCDQsdCw0L3QutC4INCR0YPRhdC-0YDQviDQmtCR0JrQnA!8m2!3d39.7771924!4d64.4427832!16s%2Fg%2F11ybx832hc!3m5!1s0x3f50059e4be78105:0xdffcc32a2eefa04e!8m2!3d39.7771924!4d64.4427832!16s%2Fg%2F11ybx832hc?entry=ttu&g_ep=EgoyMDI1MDEyNy4wIKXMDSoASAFQAw%3D%3D" target='_blank'  rel="noopener noreferrer">
                <i class="fa-solid fa-location-dot"></i>
                </a>
            </div>
        </div>
    </section>
  )
}
export default Footer
